import * as React from 'react';
import {useState} from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import {useNavigate} from "react-router-dom";
import {makeApiCall} from "../../hooks/CancellableApiCall";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import {DialogActions, DialogContent} from "@mui/material";

interface DeleteActivityNoticePromptProps {
    id: number,
    communityId: string
}

export default function DeleteActivityNoticePrompt(props: DeleteActivityNoticePromptProps) {
    const [open, setOpen] = useState(false);
    const navigate = useNavigate()

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <React.Fragment>
            <DeleteForeverIcon color={"error"} onClick={() => setOpen(true)}/>
            <Dialog open={open} onClose={handleClose}>
                <DialogContent>Remove Inactivity Notice</DialogContent>
                <DialogActions>
                    <Button color={"success"} onClick={handleClose}>Cancel</Button>
                    <Button color={"error"} onClick={() =>
                        makeApiCall({
                            url: `/api/activity/${props.communityId}/${props.id}/delete`,
                            method: "DELETE",
                            onLoadedCallback: () => {
                                navigate(`/user/${props.communityId}`)
                            },
                            onError: () => {
                                handleClose()
                            }
                        })
                    }>Remove Activity Entry</Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}